import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IAcceptMeetingRequestByTokenPayload } from '@app-store/slices/meetingRequests/acceptByToken'

interface TaskAction extends Action {
    payload: IAcceptMeetingRequestByTokenPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingRequests.acceptByToken

function* acceptMeetingRequestByTokenSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/meeting/meeting-requests/accept`, {
            params: {
                token: payload.token,
                time: payload.time
            }
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        if (payload?.sagaCB?.onError) payload?.sagaCB?.onError()
    }
}

function* acceptMeetingRequestByTokenSaga(): any {
    yield takeLatest<TaskAction>(onRequest, acceptMeetingRequestByTokenSagaTask)
}

export default acceptMeetingRequestByTokenSaga
